import { useEffect, useMemo, useState } from "react";
import TableDateFormatter from "../BulkUpdateSettings/TableDateFormatter"
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import { adminService } from "../../../services/admin-services";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import { Typography } from "@mui/material";

const SourceFormatter = (gridProps) => {
    try {
        let source = gridProps?.value?.toLowerCase();
        if (source) {
            if (source.includes('campaign')) return "Campaign"
            if (source.includes('agent')) return "Agent"
        }
    } catch (e) {
        console.error(e)
    }
    return gridProps?.value;
}

export default function BulkOperationStatus() {

    const [gridRef, setGridRef] = useState(null);
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const controller = new AbortController();
        getTransactionStatusList(controller)
        return () => controller.abort();
    }, [])

    const bulkOperationsTranscationStatusTabColumnDefs = useMemo(() => ([
        { field: 'transactionId', headerName: 'Transaction ID', minWidth: 150 },
        { field: 'uploadSource', headerName: 'Source', minWidth: 150, cellRenderer: SourceFormatter },
        { field: 'processStarttime', headerName: 'Start Time', minWidth: 150, cellRenderer: TableDateFormatter },
        { field: 'processEndtime', headerName: 'End Time', minWidth: 150, cellRenderer: TableDateFormatter },
        { field: 'uploadStatus', headerName: 'Status', minWidth: 150, },
        { field: 'messageSent', headerName: 'Message', minWidth: 160, },
    ]
    ), [])

    async function getTransactionStatusList(controller) {
        setLoading(true);
        try {
            const resp = await adminService({
                urlParams: 'dataManagement/user/transactions',
                method: 'GET',
                controller
            })
            if (resp && Array.isArray(resp?.Data) && resp?.Data?.length > 0) {
                setTransactions(resp.Data);
            } else {
                throw new Error("No data found")
            }
        } catch (e) {
            setTransactions([])
            console.error(e)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div>
            <Typography
                sx={{ fontSize: "0.75rem", lineHeight: "0.875rem", marginBottom: "0.625rem", color: "#212121", }} alignSelf="center">
                Configurations
            </Typography>
            <Typography
                sx={{ fontStyle: "normal", fontWeight: 600, fontSize: "1.5rem", lineHeight: "1.75rem" }} flexGrow={1}>
                Bulk Operation Status
            </Typography>
            <OZGridToolbar
                title='List of Bulk Operations'
                rowCount={transactions?.length || 0}
                dataGridRef={gridRef}
                fileName='Dispositions'
            />
            {loading ?
                <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: 'calc(100vh + 60px)', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1 }} >
                    <LoadingScreen />
                </div>
                :
                <OZDataGrid
                    height='23.5rem'
                    columns={bulkOperationsTranscationStatusTabColumnDefs}
                    data={transactions}
                    setGridRef={setGridRef}
                    name={"Bulk Operations"}
                />
            }
        </div>
    )
}
